import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_34jwv28ejh: FaireBrandEntity = {
  token: "b_34jwv28ejh",
  type: "brand",
  name: "Zerra & Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/a9a65dbe3d9e52119ce174496ed7cf356be75a8e37d30a923daea341c2e7ebd4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/96da3eb7d7efe524d88485be7ea19e616cad39a40fc7b66af004fa14f9956faa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a9a65dbe3d9e52119ce174496ed7cf356be75a8e37d30a923daea341c2e7ebd4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/96da3eb7d7efe524d88485be7ea19e616cad39a40fc7b66af004fa14f9956faa.jpeg",
  location: "Baltimore, MD, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 71,
  isTopShop: true,
  isInsider: true,
  description:
    "Zerra & Co. creates cruelty free and vegan makeup and skincare for zero waste retail. Our products feature refillable glass, metal, and bamboo packaging with bulk skincare refill options available, making it easy to stock skincare essentials for your refill station or offer effective plastic free beauty. Our free container return program creates a closed loop system—you and your customers send empties back to us for reuse at no cost.\n\nAll of our products are Leaping Bunny Certified Cruelty Free and we’re a proud 1% for the Planet member with our 1% benefitting Blue Water Baltimore, a local non-profit that protects our city’s watershed.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.563Z",
    importedBy: "entity-db-cli",
  },
};
